<template>
  <div class="user-profile">
    <!-- <div class="p-3" style="background-color: var(--corelightcolor); margin-top: 15px; border-bottom-left-radius: 7px; border-top-left-radius: 7px;">
      <h1 style="color: #fff; font-weight: 700;">My Profile</h1>
    </div> -->
    <div class="pt-3 pl-3 pb-2" style="background-color: var(--bootstrapgrey); border-bottom-left-radius: 0px; border-top-left-radius: 0px;">
      <h3 class="section-title" style="text-transform: uppercase; font-weight: 400; color: #000;">My Profile</h3>
    </div>

    <!-- <button @click="makemecoach()">Make Me Coach</button> -->

    <!-- <form action="" class="mt-2 mx-2" v-if="!editing">
      <h3 class="section-header" v-if="showGeneralInfo">General Information</h3>
      <div class="row" v-if="showGeneralInfo">
        <div class="col-lg-6 form-group">
          <label v-if="user.first_name || user.last_name">Name</label>
          <p class="profile-element">{{ user.first_name }} {{ user.last_name }}</p>
          <label v-if="user.birthday">Birthday</label>
          <p class="profile-element">{{ user.birthday }}</p>
          <label v-if="user.gender">Gender</label>
          <p class="profile-element">{{ user.gender }}</p>
        </div>
        <div class="col-lg-6 form-group">
          <label v-if="showGeneralInfo">Preferred Distance Units</label>
          <p v-if="showGeneralInfo" class="profile-element">{{ user.preferred_distance_units }}</p>
          <label v-if="user.weight">Weight</label>
          <p class="profile-element">{{ user.weight }} {{ user.weight_units }}</p>
          <label v-if="user.height">Height</label>
          <p class="profile-element">{{ user.height }} {{ user.height_units }}</p>
        </div>
      </div>
      <hr v-if="showGeneralInfo">
      <hr v-if="showGeneralInfo">
      <h3 class="section-header" v-if="showContactInfo">Contact Information</h3>
      <div class="row" v-if="showContactInfo">
        <div class="col-lg-6 form-group">
          <label v-if="user.home_phone">Home Phone</label>
          <p class="profile-element">{{ user.home_phone }}</p>
          <label v-if="user.business_phone">Business Phone</label>
          <p class="profile-element">{{ user.business_phone }}</p>
          <label v-if="user.cell_phone">Cell Phone</label>
          <p class="profile-element">{{ user.cell_phone }}</p>
          <label v-if="user.alternate_email">Alternate Email</label>
          <p class="profile-element">{{ user.alternate_email }}</p>
        </div>
        <div class="col-lg-6 form-group">
          <label v-if="user.address1">Address</label>
          <p class="profile-element">{{ user.address1 }}</p>
          <p class="profile-element">{{ user.address2 }}</p>
          <p class="profile-element">{{ user.city }}<span v-if="user.city">, </span>{{ user.provincestate }}<span v-if="user.provincestate">, </span>{{ user.country }}</p>
          <p class="profile-element">{{ user.postal_code }}</p>
        </div>
      </div>
      <hr v-if="showContactInfo">
      <hr v-if="showContactInfo">
      <h3 class="section-header" v-if="showRunningHistory">Running History</h3>
      <div class="row" v-if="showRunningHistory">
        <div class="col-lg-6">
          <label v-if="user.furthest_event">Furthest distance run/event</label>
          <p class="profile-element">{{ user.furthest_event }}</p>
        </div>
        <div class="col-lg-6 form-group">
          <label v-if="user.num5k != null || user.num10k != null || user.num_halfs != null || user.num_marathons != null || user.num_ultras != null || user.num_triathalons != null">Number of races completed</label>
          <p class="profile-element" v-if="user.num5k != null">5Ks: {{ user.num5k }}</p>
          <p class="profile-element" v-if="user.num10k != null">10Ks: {{ user.num10k }}</p>
          <p class="profile-element" v-if="user.num_halfs != null">Half Marathons: {{ user.num_halfs }}</p>
          <p class="profile-element" v-if="user.num_marathons != null">Marathons: {{ user.num_marathons }}</p>
          <p class="profile-element" v-if="user.num_ultras != null">UltraMarathons: {{ user.num_ultras }}</p>
          <p class="profile-element" v-if="user.num_triathalons != null">Triathalons: {{ user.num_triathalons }}</p>
        </div>
      </div>
      <hr v-if="showRunningHistory">
      <div class="row" v-if="showRunningHistory">
        <div class="col-lg-6 form-group">
          <label v-if="user.recent_weekly_distance">In the last 4 weeks, I have been running</label>
          <p v-if="user.recent_weekly_distance" class="profile-element">{{ user.recent_weekly_distance / 1000 }} {{ user.preferred_distance_units }} per week</p>
          <label v-if="user.recent_weekly_days">In the last 4 weeks, I have been running</label>
          <p v-if="user.recent_weekly_days" class="profile-element">{{ user.recent_weekly_days }} days per week</p>
          <label v-if="user.recent_longest_run">In the last 4 weeks, my longest run has been</label>
          <p v-if="user.recent_longest_run" class="profile-element">{{ user.recent_longest_run / 1000 }} {{ user.preferred_distance_units }}</p>
        </div>
        <div class="col-lg-6 form-group">
          <label v-if="user.longterm_weekly_distance">Over the last 2 years, the greatest distance I ran per week</label>
          <p v-if="user.longterm_weekly_distance" class="profile-element">{{ user.longterm_weekly_distance / 1000 }} {{ user.preferred_distance_units }}</p>
          <label v-if="user.longterm_weekly_days">Over the last 2 years, the greatest number of days I ran per week regularly</label>
          <p v-if="user.longterm_weekly_days" class="profile-element">{{ user.longterm_weekly_days }}</p>
          <label v-if="user.longterm_longest_run">Over the last 2 years, my single longest run in training was</label>
          <p v-if="user.longterm_longest_run" class="profile-element">{{ user.longterm_longest_run / 1000 }} {{ user.preferred_distance_units }}</p>
        </div>
      </div>
      <hr v-if="showRunningHistory">
      <div class="row" v-if="showRunningHistory">
        <div class="col-lg-6 form-group">
          <label v-if="user.best5k || user.best5k_hours || user.best5k_minutes">Best 5k race this year</label>
          <p class="profile-element">{{ user.best5k }}<span v-if="user.best5k">: </span><span v-if="user.best5k_hours || user.best5k_minutes">{{ user.best5k_hours }}<span v-if="user.best5k_hours">:</span>{{ user.best5k_minutes | twoDigits }}:{{ user.best5k_seconds | singleDecimalSeconds }}</span></p>
          <label v-if="user.best10k || user.best10k_hours || user.best10k_minutes">Best 10k race this year</label>
          <p class="profile-element">{{ user.best10k }}<span v-if="user.best10k">: </span><span v-if="user.best10k_hours || user.best10k_minutes">{{ user.best10k_hours }}<span v-if="user.best10k_hours">:</span>{{ user.best10k_minutes | twoDigits }}:{{ user.best10k_seconds | singleDecimalSeconds }}</span></p>
          <label v-if="user.best_half || user.best_half_hours || user.best_half_minutes">Best half marathon race this year</label>
          <p class="profile-element">{{ user.best_half }}<span v-if="user.best_half">: </span><span v-if="user.best_half_hours || user.best_half_minutes">{{ user.best_half_hours }}<span v-if="user.best_half_hours">:</span>{{ user.best_half_minutes | twoDigits }}:{{ user.best_half_seconds | singleDecimalSeconds }}</span></p>
          <label v-if="user.best_marathon || user.best_marathon_hours || user.best_marathon_minutes">Best marathon race this year</label>
          <p class="profile-element">{{ user.best_marathon }}<span v-if="user.best_marathon">: </span><span v-if="user.best_marathon_hours || user.best_marathon_minutes">{{ user.best_marathon_hours }}<span v-if="user.best_marathon_hours">:</span>{{ user.best_marathon_minutes | twoDigits }}:{{ user.best_marathon_seconds | singleDecimalSeconds }}</span></p>
        </div>
        <div class="col-lg-6 form-group">
          <label v-if="user.recent_races">Races in the past 4-8 weeks</label>
          <p class="profile-element">{{ user.recent_races }}</p>
          <label v-if="user.recent_race_comments">Additional info/comments on these races</label>
          <p class="profile-element">{{ user.recent_race_comments }}</p>
          <label v-if="user.recent_injuries">Any injuries in the last 8-12 weeks?</label>
          <p class="profile-element" v-if="user.recent_injuries">Yes</p>
          <p class="profile-element" v-if="user.recent_injuries == false">No</p>
          <p class="profile-element">{{ user.injury_notes }}</p>
        </div>
      </div>
      <hr v-if="showRunningHistory">
      <hr v-if="showRunningHistory">
      <h3 class="section-header" v-if="showTrainingPlanning">Training Planning</h3>
      <div class="row" v-if="showTrainingPlanning">
        <div class="col-lg-12">
          <label v-if="user.goal_race">Goal race for the season</label>
          <p class="profile-element">{{ user.goal_race }}</p>
        </div>
      </div>
      <hr v-if="user.goal_race">
      <div class="row" v-if="showTrainingPlanning">
        <div class="col-lg-6 form-group">
          <label v-if="user.heartrate_monitor">Heart rate monitor?</label>
          <p class="profile-element" v-if="user.heartrate_monitor">Yes</p>
          <p class="profile-element" v-if="user.heartrate_monitor == false">No</p>
          <label v-if="user.long_day">Preferred day for your LONG run?</label>
          <p class="profile-element">{{ user.long_day }}</p>
          <label v-if="user.speed_day">Preferred day for your SPEED run?</label>
          <p class="profile-element">{{ user.speed_day }}</p>
          <label v-if="user.rest_day">Preferred day for your DAY OFF?</label>
          <p class="profile-element">{{ user.rest_day }}</p>
        </div>
        <div class="col-lg-6 form-group">
          <label v-if="user.training_aspects[0]">3 training-related aspects would you like to track during your training schedule?</label>
          <p v-for="(training_aspect, index) in user.training_aspects" :key="index" class="profile-element">{{ training_aspect }}</p>
        </div>
      </div>
      <hr v-if="user.xtraining_amount || user.xtraining_days[0] || user.xtraining_description">
      <div class="row" v-if="showTrainingPlanning">
        <div class="col-lg-6 form-group">
          <label v-if="user.xtraining_amount">How much aerobic cross-training (cycle, swim, etc) do you plan to do?</label>
          <p class="profile-element">{{ user.xtraining_amount }}</p>
          <label v-if="user.xtraining_days[0]">Preferred days to aerobically cross-train</label>
          <p v-for="(xtraining_day, index) in user.xtraining_days" :key="index" class="profile-element">{{ xtraining_day }}</p>
        </div>
        <div class="col-lg-6 form-group">
          <label v-if="user.xtraining_description">Other (non-aerobic) cross-training</label>
          <p class="profile-element">{{ user.xtraining_description }}</p>
        </div>
      </div>
      <hr v-if="showTrainingPlanning">
      <hr v-if="showTrainingPlanning">
      <h3 class="section-header" v-if="showMileTrial">Mile Trial</h3>
      <label v-if="user.mile_minutes">Mile Time</label>
      <p v-if="user.mile_minutes" class="profile-element">{{ user.mile_minutes }}:{{ user.mile_seconds | twoDigits }}</p>
      <label v-if="user.mile_location">Location</label>
      <p class="profile-element">{{ user.mile_location }}</p>
      <label v-if="user.mile_surface">Surface</label>
      <p class="profile-element">{{ user.mile_location }}</p>
      <label v-if="user.mile_splits">Mile Splits</label>
      <p class="profile-element">{{ user.mile_splits }}</p>
      <hr v-if="showMileTrial">
      <button class="btn btn-primary mt-3" style="display: block;" @click.prevent="editing = true">Edit</button>
    </form> -->

    <div v-if="!editing">
      <button class="btn btn-primary mt-3" style="display: block;" @click.prevent="editProfile()">Edit Profile</button>
      <app-user-profile-info :user="user"></app-user-profile-info>
      <button v-if="user.first_name" class="btn btn-primary mt-3" style="display: block;" @click.prevent="editProfile()">Edit Profile</button>
    </div>

    <div v-if="editing">
      <app-user-profile-edit :user="user" @profileSaved="profileSaved()" @cancel="cancelProfileEdit()"></app-user-profile-edit>
      <!-- <button class="btn btn-primary mt-3" style="display: block;" @click.prevent="editProfile()">Edit</button> -->
    </div>

    <!--------- FORM --------->
    <!-- <form action="" v-if="editing" class="mx-1 mt-3">
      <h3 class="section-header">General Information</h3>
      <div class="row">

        <div class="col-lg-6">
          <div class="form-group">
            <div class="form-row">
              <div class="col-lg-6">
                <label for="">First Name</label>
                <input type="text" class="form-control" name="" id="" v-model="firstName">
              </div>
              <div class="col-lg-6">
                <label for="">Last Name</label>
                <input type="text" class="form-control" name="" id="" v-model="lastName">
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="raceDate">Birthday</label>
            <div class="input-group">
              <input type="number" name="" id="" placeholder="YYYY" class="form-control" v-model="birthYear">
              <input type="number" name="" id="" placeholder="MM" class="form-control" v-model="birthMonth">
              <input type="number" name="" id="" placeholder="DD" class="form-control" v-model="birthDay">
            </div>
          </div>
          <div class="form-group">
            <label for="">Gender</label>
            <select class="form-control" id="" v-model="gender">
              <option>M</option>
              <option>F</option>
              <option>-</option>
            </select>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="">Preferred Distance Units</label>
            <select class="form-control" id="" v-model="distanceUnits">
              <option>km</option>
              <option>mi</option>
            </select>
          </div>

          <div class="form-group">
            <label for="">Weight</label>
            <div class="form-row">
              <div class="col-md-8">
                <input type="number" name="" id="" placeholder="" class="form-control" v-model="weight">
              </div>
              <div class="col-md-4">
                <select class="form-control" id="" v-model="weightUnits">
                  <option>lbs</option>
                  <option>kg</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Height</label>
            <div class="form-row">
              <div class="col-md-8">
                <div v-if="heightUnits == 'imperial'">
                  <div class="input-group">
                    <input type="number" placeholder="feet" class="form-control" v-model="height_ft">
                    <input type="number" placeholder="inches" class="form-control" v-model="height_in">
                  </div>
                </div>
                <div v-if="heightUnits == 'metric'">
                  <input type="number" placeholder="centimeters" class="form-control" v-model="height_cm">
                </div>
              </div>
              <div class="col-md-4">
                <select class="form-control" v-model="heightUnits">
                  <option>imperial</option>
                  <option>metric</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <h3 class="section-header">Contact Information</h3>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label>Home Phone</label>
            <input type="text" class="form-control" name="" id="" v-model="homePhone">
          </div>
          <div class="form-group">
            <label for="">Business Phone</label>
            <input type="text" class="form-control" name="" id="" v-model="businessPhone">
          </div>
          <div class="form-group">
            <label for="">Cell Phone</label>
            <input type="text" class="form-control" name="" id="" v-model="cellPhone">
          </div>
          <div class="form-group">
            <label for="">Alternate Email</label>
            <input type="text" class="form-control" v-model="alternateEmail" placeholder="Other than what you used to register your account">
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="">Address Line 1</label>
            <input type="text" class="form-control" v-model="address1">
          </div>
          <div class="form-group">
            <label for="">Address Line 2</label>
            <input type="text" class="form-control" v-model="address2">
          </div>
          <div class="form-row form-group">
            <div class="col-md-6">
              <label for="">City</label>
              <input type="text" class="form-control" v-model="city">
            </div>
            <div class="col-md-6">
              <label for="">Postal Code</label>
              <input type="text" class="form-control" v-model="postalCode">
            </div>
          </div>
          <div class="form-row form-group">
            <div class="col-md-6">
              <label for="">Province</label>
              <input type="text" class="form-control" v-model="province">
            </div>
            <div class="col-md-6">
              <label for="">Country</label>
              <input type="text" class="form-control" v-model="country">
            </div>
          </div>
        </div>
      </div>
      <hr>
      <h3 class="section-header">Running History</h3>
      <div class="row form-group">
        <div class="col-lg-6">
          <label for="">What is the furthest distance run or event you have completed?</label>
          <select class="form-control" v-model="furthestEvent">
            <option v-for="(distance, index) in distances" :key="index">{{ distance }}</option>
          </select>
        </div>
        <div class="col-lg-6 form-group">
          <label for="">If you have completed any races of the following distances, how many?</label>
          <small style="display: block;" class="mb-3">If you can't remember exactly, don't worry, just guess approximately!</small>
          <div class="">
            <input type="number" name="" id="" placeholder="How many 5Ks?" class="form-control" v-model="num5k">
          </div>
          <div class="mt-1">
            <input type="number" name="" id="" placeholder="How many 10Ks?" class="form-control" v-model="num10k">
          </div>
          <div class="mt-1">
            <input type="number" name="" id="" placeholder="How many half marathons?" class="form-control" v-model="numHalfs">
          </div>
          <div class="mt-1">
            <input type="number" name="" id="" placeholder="How many marathons?" class="form-control" v-model="numMarathons">
          </div>
          <div class="mt-1">
            <input type="number" name="" id="" placeholder="How many ultra marathons?" class="form-control" v-model="numUltras">
          </div>
          <div class="mt-1">
            <input type="number" name="" id="" placeholder="How many triathalons?" class="form-control" v-model="numTriathalons">
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-lg-6">
          <div class="">
            <label for="">In the last 4 weeks, how far have you been running per week?</label>
            <div class="input-group">
              <input type="number" class="form-control" v-model="recentWeeklyDistance">
              <div class="input-group-append mb-1">
                <span class="input-group-text">{{ distanceUnits }}</span>
              </div>
            </div>
          </div>
          <div class="">
            <label for="">In the last 4 weeks, how many days per week are you running?</label>
            <div class="form-row">
              <div class="col-md-12 mb-1">
                <input type="number" name="" id="" placeholder="" class="form-control" v-model="recentWeeklyDays">
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">In the last 4 weeks, how far has your longest run been?</label>
            <div class="input-group">
              <input type="number" name="" id="" placeholder="" class="form-control" v-model="recentLongestRun">
              <div class="input-group-append mb-1">
                <span class="input-group-text" id="" style="">{{ distanceUnits }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="">
            <label for="">Over the last 2 years, what is the greatest distance you ran per week?</label>
            <div class="input-group">
              <input type="number" class="form-control" v-model="longtermWeeklyDistance">
              <div class="input-group-append mb-1">
                <span class="input-group-text">{{ distanceUnits }}</span>
              </div>
            </div>
          </div>
          <div class="">
            <label for="">Over the last 2 years, what is the greatest number of days you ran per week regularly?</label>
            <div class="form-row">
              <div class="col-md-12 mb-1">
                <input type="number" placeholder="" class="form-control" v-model="longtermWeeklyDays">
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="">Over the last 2 years, what is the single longest run in training?</label>
            <div class="input-group">
              <input type="number" class="form-control" v-model="longtermLongestRun">
              <div class="input-group-append mb-1">
                <span class="input-group-text">{{ distanceUnits }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-lg-6 form-group">
          <div class="">
            <label for="">What is your best 5k race time in the past 12 months?</label>
            <div class="input-group" style="">
              <input type="number" class="form-control mb-1" id="" placeholder="hours" v-model="best5kHours" style="">
              <div class="input-group-append mb-1">
                <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
              </div>
              <input type="number" class="form-control mb-1" id="" placeholder="mins" v-model="best5kMins" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
              <div class="input-group-append mb-1">
                <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
              </div>
              <input type="number" class="form-control mb-1" id="" placeholder="secs" v-model="best5kSecs" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
            </div>
            <input type="text" class="form-control" v-model="best5k" placeholder="What 5k race was this?">
          </div>

          <label for="">What is your best 10k race time in the past 12 months?</label>
          <div class="input-group" style="">
            <input type="number" class="form-control mb-1" id="" placeholder="hours" v-model="best10kHours" style="">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control mb-1" id="" placeholder="mins" v-model="best10kMins" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control mb-1" id="" placeholder="secs" v-model="best10kSecs" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>
          <input type="text" class="form-control" v-model="best10k" placeholder="What 10k race was this?">

          <label for="">What is your best half marathon race time in the past 12 months?</label>
          <div class="input-group" style="">
            <input type="number" class="form-control mb-1" id="" placeholder="hours" v-model="bestHalfHours" style="">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control mb-1" id="" placeholder="mins" v-model="bestHalfMins" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control mb-1" id="" placeholder="secs" v-model="bestHalfSecs" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>
          <input type="text" class="form-control" v-model="bestHalf" placeholder="What half marathon race was this?">

          <label for="">What is your best marathon race time in the past 12 months?</label>
          <div class="input-group" style="">
            <input type="number" class="form-control mb-1" id="" placeholder="hours" v-model="bestMarathonHours" style="">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control mb-1" id="" placeholder="mins" v-model="bestMarathonMins" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control mb-1" id="" placeholder="secs" v-model="bestMarathonSecs" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>
          <input type="text" class="form-control" v-model="bestMarathon" placeholder="What marathon race was this?">
        </div>

        <div class="col-lg-6 form-group">
          <label for="">What races and times have you done in the past 4-8 weeks, if any?</label>
          <textarea class="form-control" id="" rows="3" v-model="recentRaces" placeholder=""></textarea>
          <label for="">Any additional info/comments on these races?</label>
          <textarea class="form-control" id="" rows="3" v-model="recentRaceComments" placeholder="(ie: weather, course, circumstance)"></textarea>
          <label>Any injuries in the last 8-12 weeks?</label>
          <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" :value="true" v-model="recentInjuries">
              <label class="form-check-label">Yes</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" :value="false" v-model="recentInjuries">
              <label class="form-check-label">No</label>
            </div>
          </div>
          <div v-if="recentInjuries">
            <label>Injuries</label>
            <div v-for="(injury, index) in injuryOptions" :key="index">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" :value='injury' v-model="injuries">
                <label class="form-check-label" style="margin-top: 0">
                  {{ injury }}
                </label>
              </div>
            </div>
            <input type="text" class="form-control mt-1" v-model="otherInjuries" placeholder="Other Injuries">

            <label for="">Please explain/describe your injuries</label>
            <textarea class="form-control" id="" rows="2" v-model="injuryNotes" placeholder=""></textarea>
          </div>

        </div>
      </div>
      <hr>
      <h3 class="section-header">Training Planning</h3>

      <div class="row">
        <div class="form-group col-lg-6">
          <label>Which season are you planning for?</label>
          <select class="form-control" v-model="season">
            <option>Winter/Spring</option>
            <option>Summer/Fall</option>
          </select>
          <label>What is your coaching level?</label>
          <select class="form-control" v-model="plan">
            <option v-for="(option, index) in planOptions" :key="index">{{ option }}</option>
          </select>
        </div>
      </div>

      <div class="row form-group" v-if="plan == 'Personal/Group Coaching (Bronze)' || plan == 'Personal/Group Coaching (Silver)' || plan == 'Personal/Group Coaching (Gold)'">
        <div class="col-lg-6">
          <label :class="{'unavailable': season != 'Winter/Spring'}">Winter/Spring Season Groups</label>
          <div v-for="(category, index) in categoriesOptions" :key='index'>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :value='category' v-model="categories" v-if="season == 'Winter/Spring'">
              <label class="form-check-label" style="margin-top: 0" :class="{'unavailable': season != 'Winter/Spring'}">
                {{ category }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <label :class="{'unavailable': season != 'Summer/Fall'}">Summer/Fall Season Groups</label>
          <div v-for="(category, index) in categories2Options" :key='index'>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :value='category' v-model="categories2" v-if="season == 'Summer/Fall'">
              <label class="form-check-label" style="margin-top: 0" :class="{'unavailable': season != 'Summer/Fall'}">
                {{ category }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <label :class="{'unavailable': season != 'Winter/Spring'}">Winter (Mid Season) Races</label>
          <div v-for="(race, index) in winterRaceOptions" :key="index">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :value='race.name' v-model="winterRaces" v-if="season == 'Winter/Spring'">
              <label class="form-check-label" style="margin-top: 0" :class="{'unavailable': season != 'Winter/Spring'}">
                <a :href="race.link" target="_blank" :class="{'unavailable': season != 'Winter/Spring'}">{{ race.name }}</a> ({{ race.date }})
              </label>
            </div>
          </div>
          <input type="text" class="form-control mt-1" v-model="otherWinterRaces" placeholder="Other Winter Race" :class="{'unavailable': season != 'Winter/Spring'}">
        </div>
        <div class="col-lg-6">
          <label :class="{'unavailable': season != 'Winter/Spring'}">Spring (Target) Races</label>
          <div v-for="(race, index) in springRaceOptions" :key="index">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :value='race.name' v-model="springRaces" v-if="season == 'Winter/Spring'">
              <label class="form-check-label" style="margin-top: 0" :class="{'unavailable': season != 'Winter/Spring'}">
                <a :href="race.link" target="_blank" :class="{'unavailable': season != 'Winter/Spring'}">{{ race.name }}</a> ({{ race.date }})
              </label>
            </div>
          </div>
          <input type="text" class="form-control mt-1" v-model="otherSpringRaces" placeholder="Other Spring Race" :class="{'unavailable': season != 'Winter/Spring'}">
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <label :class="{'unavailable': season != 'Summer/Fall'}">Summer (Mid Season) Races</label>
          <div v-for="(race, index) in summerRaceOptions" :key="index">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :value='race.name' v-model="summerRaces" v-if="season == 'Summer/Fall'">
              <label class="form-check-label" style="margin-top: 0" :class="{'unavailable': season != 'Summer/Fall'}">
                <a :href="race.link" target="_blank" :class="{'unavailable': season != 'Summer/Fall'}">{{ race.name }}</a> ({{ race.date }})
              </label>
            </div>
          </div>
          <input type="text" class="form-control mt-1" v-model="otherSummerRaces" placeholder="Other Summer Race" :class="{'unavailable': season != 'Summer/Fall'}">
        </div>
        <div class="col-lg-6">
          <label :class="{'unavailable': season != 'Summer/Fall'}">Fall (Target) Races</label>
          <div v-for="(race, index) in fallRaceOptions" :key="index">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :value='race.name' v-model="fallRaces" v-if="season == 'Summer/Fall'">
              <label class="form-check-label" style="margin-top: 0" :class="{'unavailable': season != 'Summer/Fall'}">
                <a :href="race.link" target="_blank" :class="{'unavailable': season != 'Summer/Fall'}">{{ race.name }}</a> ({{ race.date }})
              </label>
            </div>
          </div>
          <input type="text" class="form-control mt-1" v-model="otherFallRaces" placeholder="Other Fall Race" :class="{'unavailable': season != 'Summer/Fall'}">
        </div>
      </div>
      <p class="mt-2">Want to research more race options? Check out <a href='https://www.runguides.com/' target="_blank">runguides.com</a> (national and international races) and <a href="https://www.roadraceresults.com/default.php" target="_blank">roadraceresults.com</a> (local, GTA, and Southern Ontario Races)</p>
      <div class="row form-group">
        <div class="col-lg-12">
          <label for="">Any race goals for the season?</label>
          <textarea class="form-control" id="" rows="3" v-model="goalRace" placeholder="Do you have any goal times or any non-time related goals for the races/season?"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 form-group">
          <label for="">Do you use a heart rate monitor?</label>
          <small style="display: block;" class="">Not required for our program, but we can help you use it if you do.</small>
          <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" :value="true" v-model="heartrateMonitor">
              <label class="form-check-label">Yes</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" :value="false" v-model="heartrateMonitor">
              <label class="form-check-label">No</label>
            </div>
          </div>
          <label>Preferred day for your LONG run?</label>
          <select class="form-control" v-model="longDay">
            <option v-for="(day, index) in days" :key="index">{{ day }}</option>
          </select>
          <label>Preferred day for your SPEED run?</label>
          <select class="form-control" v-model="speedDay">
            <option v-for="(day, index) in days" :key="index">{{ day }}</option>
          </select>
          <label>Preferred day for your DAY OFF?</label>
          <select class="form-control" v-model="restDay">
            <option v-for="(day, index) in days" :key="index">{{ day }}</option>
          </select>
        </div>
        <div class="col-lg-6 form-group">
          <label for="">What 3 of the following training-related aspects would you like to track during your training schedule?</label>
          <small style="display: block;" class="mb-1">Please choose only 3</small>
          <div v-for="(trainingAspect, index) in trainingAspectOptions" :key='index'>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :value='trainingAspect' v-model="trainingAspects">
              <label class="form-check-label" style="margin-top: 0">
                {{ trainingAspect }}
              </label>
            </div>
          </div>
          <input type="text" class="form-control mt-1" v-model="otherTrainingAspects" placeholder="Other Training Aspects">
        </div>
      </div>
      <div class="row form-group">
        <div class="col-lg-6">
          <label for="">How much aerobic cross-training (cycle, swim, etc) do you plan to do?</label>
          <select class="form-control" v-model="xtrainingAmount">
            <option>High (2+ hours / week)</option>
            <option>Medium (1-2 hours / week)</option>
            <option>Low (less than 1 hour / week)</option>
            <option>None (0 hours / week)</option>
          </select>
          <label for="">Your preferred days to aerobically cross-train?</label>
          <small style="display: block;" class="mb-1">(choose one or more)</small>
          <div v-for="(day, index) in days" :key='index'>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :value='day' v-model="xtrainingDays">
              <label class="form-check-label" style="margin-top: 0">
                {{ day }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-6 form-group">
          <label>Preferred aerobic x-training activites?</label>
          <div v-for="(activity, index) in xtrainingActivityOptions" :key='index'>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :value='activity' v-model="xtrainingActivities">
              <label class="form-check-label" style="margin-top: 0">
                {{ activity }}
              </label>
            </div>
          </div>
          <input type="text" class="form-control mt-1" v-model="otherXtrainingActivities" placeholder="Other Aerobic X-Training">
          <label>Describe any other (non-aerobic) cross-training that you do, if any</label>
          <textarea class="form-control" rows="2" v-model="xtrainingDescription" placeholder=""></textarea>
        </div>
      </div>
      <hr>
      <h3 class="section-header">Basic Speed Assessment - 1 Mile Trial</h3>
      <p class="mb-2">We need to determine your current "best" 1 mile run speed to help us set initial training speeds of your Customized Training Plan.</p>
      <p class="mb-2">There are 3 ways to do this:</p>
      <p class="mb-3">1 (Preferred) - MDI Coaches can test you at one of our regular weekly coaching groups (see Coaching Info for days, times, locations), and we'll update your profile here post-test.</p>
      <p class="mb-3">2 (Secondary) - You can test yourself on an accurate 400m track (or flat stretch of accurately measured road/pavement), based upon carefully following detailed self-test instructions - <a href='http://www.marathondynamics.com/display2012.php?page=1MileTrialInfo' target='_blank'>click here</a> - and enter the details as requested. If you have/use a Heart Rate Monitor wear it during the test (if not, no worries), and record your single highest HR, along with your final 1 Mile time (and any/all lap split times if you can).</p>
      <p class="mb-3">3 - If you are returning Marathon Dynamics runner (within the past 1 year only) and have run a race (half marathon distance or shorter) in the past 8 weeks (or less), then we can use that race time in lieu of a formal 1 mile trial (or can still do the 1 mile trial if you wish).</p>
      <div class="row form-group">
        <div class="col-lg-4">
          <label for="">Mile Time</label>
          <div class="input-group" style="">
            <input type="number" class="form-control" id="" placeholder="mins" v-model="mileMins" style="border-top-left-radius: ; border-bottom-left-radius: ;">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control" id="" placeholder="secs" v-model="mileSecs" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>

          <label for="">Location</label>
          <input type="text" class="form-control" v-model="mileLocation" placeholder="Road or track where you ran?">
          <label for="">Surface</label>
          <select class="form-control" id="" v-model="mileSurface">
            <option>Pavement</option>
            <option>Rubberized Track</option>
            <option>Gravel/Cinder</option>
          </select>

          <label for="">Weather Conditions</label>
          <textarea class="form-control" rows="3" v-model="mileWeather" placeholder="(ie. wind level, hard rain, base temp, windchill, humidex, etc.)"></textarea>
        </div>
        <div class="col-lg-4">
          <label>Lap 1 (400m)</label>
          <div class="input-group" style="">
            <input type="number" class="form-control" placeholder="mins" v-model="lap1Mins" style="border-top-left-radius: ; border-bottom-left-radius: ;">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control" placeholder="secs" v-model="lap1Secs" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>
          <label>Lap 2</label>
          <div class="input-group" style="">
            <input type="number" class="form-control" placeholder="mins" v-model="lap2Mins" style="border-top-left-radius: ; border-bottom-left-radius: ;">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control" placeholder="secs" v-model="lap2Secs" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>
          <label>Lap 3</label>
          <div class="input-group" style="">
            <input type="number" class="form-control" placeholder="mins" v-model="lap3Mins" style="border-top-left-radius: ; border-bottom-left-radius: ;">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control" placeholder="secs" v-model="lap3Secs" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>
          <label>Lap 4</label>
          <div class="input-group" style="">
            <input type="number" class="form-control" placeholder="mins" v-model="lap4Mins" style="border-top-left-radius: ; border-bottom-left-radius: ;">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control" placeholder="secs" v-model="lap4Secs" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>
        </div>
        <div class="col-lg-4">
          <label>800m</label>
          <div class="input-group">
            <input type="number" class="form-control" placeholder="mins" v-model="mins800m" style="border-top-left-radius: ; border-bottom-left-radius: ;">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control" placeholder="secs" v-model="secs800m" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>
          <label>1K</label>
          <div class="input-group">
            <input type="number" class="form-control" placeholder="mins" v-model="mins1k" style="border-top-left-radius: ; border-bottom-left-radius: ;">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control" placeholder="secs" v-model="secs1k" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>
          <label>Fastest Lap</label>
          <div class="input-group">
            <input type="number" class="form-control" placeholder="mins" v-model="fastestLapMins" style="border-top-left-radius: ; border-bottom-left-radius: ;">
            <div class="input-group-append mb-1">
              <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
            </div>
            <input type="number" class="form-control" placeholder="secs" v-model="fastestLapSecs" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
          </div>
          <label>Max Heart Rate</label>
          <input type="number" class="form-control" v-model="mileMaxHR">
        </div>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" :value='true' v-model="estimateMile">
        <label class="form-check-label" style="margin-top: 0">
          Use last season's end race result to estimate 1 mile speed
        </label>
      </div>
      <div v-if="estimateMile">
        <label for="">Please name the race</label>
        <input type="text" class="form-control" v-model="estimateMileRace" placeholder="">
      </div>
      <hr>
      <button class="btn btn-primary mt-3" style="" @click.prevent="saveUserProfile()">Save</button>
    </form> -->

  </div>
</template>

<script>
  import axios from 'axios'
  import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

  import UserProfileInfo from './UserProfileInfo.vue'
  import UserProfileEdit from './UserProfileEdit.vue'

  // import { timeManagement } from './mixins/timeManagement'

  export default {
    // mixins: [timeManagement],
    data () {
      return {
        user: {},
        name: '',
        firstName: '',
        lastName: '',
        birthday: '',
        birthYear: null,
        birthMonth: null,
        birthDay: null,
        gender: '',
        distanceUnits: '',
        weight: null,
        weightUnits: 'lbs',
        height: null,
        height_ft: null,
        height_in: null,
        height_cm: null,
        heightUnits: 'imperial',

        homePhone: '',
        businessPhone: '',
        cellPhone: '',
        alternateEmail: null,
        address1: '',
        address2: '',
        postalCode: '',
        city: '',
        province: '',
        country: '',

        furthestEvent: '',
        num5k: null,
        num10k: null,
        numHalfs: null,
        numMarathons: null,
        numUltras: null,
        numTriathalons: null,

        recentWeeklyDistance: null,
        recentWeeklyDistanceUnits: '',
        recentWeeklyDays: null,
        recentLongestRun: null,
        recentLongestRunUnits: '',
        longtermWeeklyDistance: null,
        longtermWeeklyDistanceUnits: '',
        longtermWeeklyDays: null,
        longtermLongestRun: null,
        longtermLongestRunUnits: '',

        best5kHours: null,
        best5kMins: null,
        best5kSecs: null,
        best5k: '',
        best10kHours: null,
        best10kMins: null,
        best10kSecs: null,
        best10k: '',
        bestHalfHours: null,
        bestHalfMins: null,
        bestHalfSecs: null,
        bestHalf: '',
        bestMarathonHours: null,
        bestMarathonMins: null,
        bestMarathonSecs: null,
        bestMarathon: '',

        recentRaces: '',
        recentRaceComments: '',
        recentInjuries: null,
        injuryNotes: '',
        injuryOptions: [],
        injuries: [],
        otherInjuries: '',

        season: '',
        plan: '',
        planOptions: [],
        categoriesOptions: [],
        categories: [],
        categories2Options: [],
        categories2: [],
        winterRaceOptions: [],
        winterRaces: [],
        otherWinterRaces: '',
        springRaceOptions: [],
        springRaces: [],
        otherSpringRaces: '',
        summerRaceOptions: [],
        summerRaces: [],
        otherSummerRaces: '',
        fallRaceOptions: [],
        fallRaces: [],
        otherFallRaces: '',
        goalRace: '',
        heartrateMonitor: null,
        longDay: '',
        speedDay: '',
        restDay: '',
        trainingAspects: [],
        otherTrainingAspects: '',
        xtrainingAmount: '',
        xtrainingDays: [],
        xtrainingDescription: '',
        xtrainingActivities: [],
        xtrainingActivityOptions: [],
        otherXtrainingActivities: '',

        mileMins: null,
        mileSecs: null,
        mileLocation: '',
        mileSurface: '',
        mileSplits: '',
        mileWeather: '',
        lap1Mins: null,
        lap1Secs: null,
        lap2Mins: null,
        lap2Secs: null,
        lap3Mins: null,
        lap3Secs: null,
        lap4Mins: null,
        lap4Secs: null,
        mins800m: null,
        secs800m: null,
        mins1k: null,
        secs1k: null,
        fastestLapMins: null,
        fastestLapSecs: null,
        mileMaxHR: null,
        estimateMile: null,
        estimateMileRace: '',

        lastUpdated: '',

        editing: false,

        distances: ['I\'m New!', '5K', '10K', 'Half Marathon', 'Marathon', 'Ultra Marathon', 'Triathalon'],
        days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        trainingAspectOptions: ['Morning Resting Heart Rate', 'Stretching', 'Morning Weight', 'Hours of Sleep', 'Strength Work', 'Health Eating', 'Rehab from Injury']
      }
    },
    components: {
      Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
      appUserProfileInfo: UserProfileInfo,
      appUserProfileEdit: UserProfileEdit,
    },
    created () {
      this.getUserProfile();
      // this.saveUserProfile();

      this.categoriesOptions = this.$store.getters.MDIwinterspringCategories
      this.categories2Options = this.$store.getters.MDIsummerfallCategories

      this.winterRaceOptions = this.$store.getters.winterRaces
      this.springRaceOptions = this.$store.getters.springRaces
      this.summerRaceOptions = this.$store.getters.summerRaces
      this.fallRaceOptions = this.$store.getters.fallRaces

      this.xtrainingActivityOptions = this.$store.getters.xtrainingActivities
      this.injuryOptions = this.$store.getters.injuries

      this.planOptions = this.$store.getters.MDIcoachingLevels
    },
    computed: {
      showGeneralInfo() {
        if (this.user.first_name || this.user.last_name || this.user.birthday || this.user.weight || this.user.height) {
          return true
        } else {
          return false
        }
      },
      showContactInfo() {
        if (this.user.home_phone || this.user.business_phone || this.user.cell_phone || this.user.alternate_email || this.user.address1 || this.user.address2 || this.user.postal_code || this.user.city || this.user.provincestate || this.user.country ) {
          return true
        } else {
          return false
        }
      },
      showRunningHistory() {
        if (this.furthestEvent || this.num5k || this.num10k || this.numHalfs || this.numMarathons || this.numTriathalons || this.recentWeeklyDistance || this.recentWeeklyDays || this.recentLongestRun || this.longtermWeeklyDistance || this.longtermWeeklyDays || this.longtermLongestRun || this.best5kHours || this.best5kMins || this.best5kSecs || this.best5k || this.best10kHours || this.best10kMins || this.best10kSecs || this.best10k || this.bestHalfHours || this.bestHalfMins || this.bestHalfSecs || this.bestHalf || this.bestMarathonHours || this.bestMarathonMins || this.bestMarathonSecs || this.bestMarathon || this.recentRaces || this.recentRaceComments || this.recentInjuries || this.injuryNotes) {
          return true
        } else {
          return false
        }
      },
      showTrainingPlanning() {
        if (this.goalRace || this.heartrateMonitor || this.longDay || this.speedDay || this.restDay || this.trainingAspects || this.xtrainingAmount || this.xtrainingDays || this.xtrainingDescription) {
          return true
        } else {
          return false
        }
      },
      showMileTrial() {
        if (this.mileMins || this.mileSecs || this.mileLocation || this.mileSurface || this.mileSplits) {
          return true
        } else {
          return false
        }
      },
      unitDivisor() {
        if (this.user.preferred_distance_units == 'km') {
          return 1000
        }
        if (this.user.preferred_distance_units == 'mi') {
          return 1609
        }
      },
    },
    methods: {
      getUserProfile () {
        this.$store.dispatch('getUser').then(() => { // Lecture 360
          this.user = this.$store.getters.user
          console.log(this.$store.getters.user)

          // this.saveUserProfile()
          this.name = this.user.name
          this.firstName = this.user.first_name
          this.lastName = this.user.last_name
          this.birthday = this.user.birthday
          if (this.birthday) {
            // this.birthday = new Date(this.birthday)
            // this.birthday = this.birthday.toDateString()
            // The birthday comes back in the format YYYY-MM-DD so we need to break it down
            // https://www.w3schools.com/jsref/jsref_split.asp
            this.birthYear = this.birthday.split('-')[0]
            this.birthMonth = this.birthday.split('-')[1]
            this.birthDay = this.birthday.split('-')[2]
          }
          this.gender = this.user.gender
          this.distanceUnits = this.user.preferred_distance_units
          this.weight = this.user.weight
          this.weightUnits = this.user.weight_units
          this.height = this.user.height
          this.heightUnits = this.user.height_units

          if (this.user.height_units == 'imperial') {
            this.height_ft = Math.floor(this.height / 12)
            this.height_in = this.height - Math.floor(this.height / 12) * 12
          }
          if (this.user.height_units == 'metric') {
            this.height_cm = this.height
          }

          this.homePhone = this.user.home_phone
          this.businessPhone = this.user.business_phone
          this.cellPhone = this.user.cell_phone
          this.alternateEmail = this.user.alternate_email
          this.address1 = this.user.address1
          this.address2 = this.user.address2
          this.postalCode = this.user.postal_code
          this.city = this.user.city
          this.province = this.user.provincestate
          this.country = this.user.country

          this.furthestEvent = this.user.furthest_event
          this.num5k = this.user.num5k
          this.num10k = this.user.num10k
          this.numHalfs = this.user.num_halfs
          this.numMarathons = this.user.num_marathons
          this.numTriathalons = this.user.num_triathalons

          this.recentWeeklyDistance = this.user.recent_weekly_distance
          if (this.recentWeeklyDistance) { this.recentWeeklyDistance = this.recentWeeklyDistance / this.unitDivisor }
          this.recentWeeklyDistanceUnits = this.user.preferred_distance_units
          this.recentWeeklyDays = this.user.recent_weekly_days
          this.recentLongestRun = this.user.recent_longest_run
          if (this.recentLongestRun) { this.recentLongestRun = this.recentLongestRun / this.unitDivisor }
          this.recentLongestRunUnits = this.user.preferred_distance_units
          this.longtermWeeklyDistance = this.user.longterm_weekly_distance
          if (this.longtermWeeklyDistance) { this.longtermWeeklyDistance = this.longtermWeeklyDistance / this.unitDivisor }
          this.longtermWeeklyDistanceUnits = this.user.preferred_distance_units
          this.longtermWeeklyDays = this.user.longterm_weekly_days
          this.longtermLongestRun = this.user.longterm_longest_run
          if (this.longtermLongestRun) { this.longtermLongestRun = this.longtermLongestRun / this.unitDivisor }
          this.longtermLongestRunUnits = this.user.preferred_distance_units

          this.best5kHours = this.user.best5k_hours
          this.best5kMins = this.user.best5k_minutes
          this.best5kSecs = this.user.best5k_seconds
          this.best5k = this.user.best5k
          this.best10kHours = this.user.best10k_hours
          this.best10kMins = this.user.best10k_minutes
          this.best10kSecs = this.user.best10k_seconds
          this.best10k = this.user.best10k
          this.bestHalfHours = this.user.best_half_hours
          this.bestHalfMins = this.user.best_half_minutes
          this.bestHalfSecs = this.user.best_half_seconds
          this.bestHalf = this.user.best_half
          this.bestMarathonHours = this.user.best_marathon_hours
          this.bestMarathonMins = this.user.best_marathon_minutes
          this.bestMarathonSecs = this.user.best_marathon_seconds
          this.bestMarathon = this.user.best_marathon

          this.recentRaces = this.user.recent_races
          this.recentRaceComments = this.user.recent_race_comments
          this.recentInjuries = this.user.recent_injuries
          this.injuryNotes = this.user.injury_notes
          this.injuries = this.user.injuries
          this.otherInjuries = this.user.other_injuries

          this.plan = this.user.plan
          this.categories = this.user.categories
          this.categories2 = this.user.categories2
          this.winterRaces = this.user.winterraces
          // console.log(this.user.winterraces)
          this.otherWinterRaces = this.user.other_winter_races
          this.springRaces = this.user.springraces
          // console.log(this.user.springraces)
          this.otherSpringRaces = this.user.other_spring_races
          // if (this.user.summer_races[0]) {
          //   this.summerRaces = this.user.summer_races
          // }
          this.summerRaces = this.user.summerraces
          // console.log(this.user.summerraces)
          this.otherSummerRaces = this.user.other_summer_races
          this.fallRaces = this.user.fallraces
          // console.log(this.user.fallraces)
          this.otherFallRaces = this.user.other_fall_races
          this.goalRace = this.user.goal_race
          this.heartrateMonitor = this.user.heartrate_monitor
          this.longDay = this.user.long_day
          this.speedDay = this.user.speed_day
          this.restDay = this.user.rest_day
          this.trainingAspects = this.user.trainingaspects
          this.otherTrainingAspects = this.user.other_training_aspects
          this.xtrainingAmount = this.user.xtraining_amount
          this.xtrainingDays = this.user.xtraining_days
          this.xtrainingDescription = this.user.xtraining_description
          this.xtrainingActivities = this.user.xtrainingactivities
          this.otherXtrainingActivities = this.user.other_xtraining_activities

          this.mileMins = this.user.mile_minutes
          this.mileSecs = this.user.mile_seconds
          this.mileLocation = this.user.mile_location
          this.mileSurface = this.user.mile_surface
          this.mileSplits = this.user.mile_splits
          this.mileWeather = this.user.mile_weather
          console.log('Lap 1')
          console.log(this.convertSecondsToTime(this.user.mile_lap1))
          console.log(this.convertSecondsToTime(this.user.mile_lap1).seconds)
          this.lap1Secs = this.convertSecondsToTime(this.user.mile_lap1).seconds
          this.lap1Mins = this.convertSecondsToTime(this.user.mile_lap1).minutes
          this.lap2Secs = this.convertSecondsToTime(this.user.mile_lap2).seconds
          this.lap2Mins = this.convertSecondsToTime(this.user.mile_lap2).minutes
          this.lap3Secs = this.convertSecondsToTime(this.user.mile_lap3).seconds
          this.lap3Mins = this.convertSecondsToTime(this.user.mile_lap3).minutes
          this.lap4Secs = this.convertSecondsToTime(this.user.mile_lap4).seconds
          this.lap4Mins = this.convertSecondsToTime(this.user.mile_lap4).minutes
          this.mins800m = this.convertSecondsToTime(this.user.mile_800).minutes
          this.secs800m = this.convertSecondsToTime(this.user.mile_800).seconds
          this.mins1k = this.convertSecondsToTime(this.user.mile_1k).minutes
          this.secs1k = this.convertSecondsToTime(this.user.mile_1k).seconds
          this.fastestLapMins = this.convertSecondsToTime(this.user.mile_fastest_lap).minutes
          this.fastestLapSecs = this.convertSecondsToTime(this.user.mile_fastest_lap).seconds
          this.mileMaxHR = this.user.mile_max_hr
          this.estimateMile = this.user.estimate_mile
          this.estimateMileRace = this.user.estimateMileRace

          // // Make the last updated date better formatted for humans
          // // https://stackoverflow.com/questions/1168807/how-can-i-add-a-key-value-pair-to-a-javascript-object
          // if (this.user.last_updated_date) {
          //   this.lastUpdated = new Date(this.user.last_updated_date).toDateString()
          // }
        })
      },
      convertDistanceToMeters (distance, units) {
        if (distance) {
          if (units == 'km') {
            return distance * 1000
          }
          else if (units == 'mi') {
            return distance * 1609
          }
          else {
            return null
          }
        } else {
          return null
        }
      },
      editProfile() {
        this.editing = true

        // Scroll the window back up to edit profile
        window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
      },
      saveUserProfile () {
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' }; // for converting the birthday to a format that works with Django
        // let djangoBirthday = ''
        // if (this.birthday != '') {
        //   // djangoBirthday = this.birthday.toLocaleDateString("en-US", options)
        //   console.log(this.birthday)
        //   this.birthday = new Date(this.birthday)
        //   this.birthday = this.birthday.toLocaleDateString("en-US", options)
        //   console.log(this.birthday)
        // }

        if (this.birthYear && this.birthMonth && this.birthDay) {
          this.birthMonth = ('0' + this.birthMonth).slice(-2)
          this.birthDay = ('0' + this.birthDay).slice(-2)
          this.birthday = this.birthYear + '-' + this.birthMonth + '-' + this.birthDay
        }
        console.log(this.birthday)

        if (this.heightUnits == 'imperial') {
          this.height = this.height_ft * 12 + this.height_in * 1
        }
        if (this.heightUnits == 'metric') {
          this.height = this.height_cm
        }

        let timeNow = new Date()
        console.log('Time Now:')
        console.log(timeNow)

        // let timeio = this.convertTimeToSeconds(null, 2, 2)
        // console.log(timeio)
        let lap1inSecs = this.convertTimeToSeconds(null, this.lap1Mins, this.lap1Secs)
        let lap2inSecs = this.convertTimeToSeconds(null, this.lap2Mins, this.lap2Secs)
        let lap3inSecs = this.convertTimeToSeconds(null, this.lap3Mins, this.lap3Secs)
        let lap4inSecs = this.convertTimeToSeconds(null, this.lap4Mins, this.lap4Secs)
        let inSecs800 = this.convertTimeToSeconds(null, this.mins800m, this.secs800m)
        let inSecs1k = this.convertTimeToSeconds(null, this.mins1k, this.secs1k)
        let fastestLapInSecs = this.convertTimeToSeconds(null, this.fastestLapMins, this.fastestLapSecs)

        // console.log(this.winterRaces)
        // console.log(this.springRaces)
        // console.log(this.summerRaces)
        // console.log(this.fallRaces)

        // There is a problem writing blank arrays to the database
        // let categories = ['']
        // if (this.categories[0]) {
        //   categories = this.categories
        // }
        // let categories2 = ['']
        // if (this.categories2[0]) {
        //   categories2 = this.categories2
        // }
        // let winter_races = ['']
        // if (this.winterRaces[0]) {
        //   winter_races = this.winterRaces
        // }
        // console.log('Number of spring races')
        // console.log(this.springRaces)
        // console.log(this.springRaces.length)
        // console.log(this.springRaces[0])
        // let spring_races = ['']
        // if (this.springRaces[0]) {
        //   spring_races = this.springRaces
        // }
        // console.log('Number of summer races')
        // console.log(this.summerRaces)
        // console.log(this.summerRaces.length)
        // // console.log(this.springRaces[0])
        // let summer_races = ['']
        // if (this.summerRaces[0]) {
        //   summer_races = this.summerRaces
        // }
        // let fall_races = ['']
        // if (this.fallRaces[0]) {
        //   fall_races = this.fallRaces
        // }
        // let training_aspects = ['']
        // if (this.trainingAspects[0]) {
        //   training_aspects = this.trainingAspects
        // }
        // let xtraining_activities = ['']
        // if (this.xtrainingActivities[0]) {
        //   xtraining_activities = this.xtrainingActivities
        // }
        // let injuries = ['']
        // if (this.injuries[0]) {
        //   injuries = this.injuries
        // }

        axios.patch('/api/users/'.concat(this.user.id.toString()).concat('/'),
          {
            // name: this.name,
            first_name: this.firstName,
            last_name: this.lastName,
            // birthday: djangoBirthday,
            // birthday: this.birthday.toLocaleDateString("en-US", options),
            // birthday: '2019-10-04',
            birthday: this.birthday,
            gender: this.gender,
            preferred_distance_units: this.distanceUnits,
            weight: this.weight,
            weight_units: this.weightUnits,
            height: this.height,
            height_units: this.heightUnits,

            home_phone: this.homePhone,
            business_phone: this.businessPhone,
            cell_phone: this.cellPhone,
            alternate_email: this.alternateEmail,
            address1: this.address1,
            address2: this.address2,
            postal_code: this.postalCode,
            city: this.city,
            provincestate: this.province,
            country: this.country,

            furthest_event: this.furthestEvent,
            num5k: this.num5k,
            num10k: this.num10k,
            num_halfs: this.numHalfs,
            num_marathons: this.numMarathons,
            num_ultras: this.numUltras,
            num_triathalons: this.numTriathalons,

            // recent_weekly_distance: this.convertDistanceToMeters(this.recentWeeklyDistance, this.recentWeeklyDistanceUnits),
            recent_weekly_distance: this.convertDistanceToMeters(this.recentWeeklyDistance, this.distanceUnits),
            recent_weekly_days: this.recentWeeklyDays,
            // recent_longest_run: this.convertDistanceToMeters(this.recentLongestRun, this.recentLongestRunUnits),
            recent_longest_run: this.convertDistanceToMeters(this.recentLongestRun, this.distanceUnits),
            // longterm_weekly_distance: this.convertDistanceToMeters(this.longtermWeeklyDistance, this.longtermWeeklyDistanceUnits),
            longterm_weekly_distance: this.convertDistanceToMeters(this.longtermWeeklyDistance, this.distanceUnits),
            longterm_weekly_days: this.longtermWeeklyDays,
            // longterm_longest_run: this.convertDistanceToMeters(this.longtermLongestRun, this.longtermLongestRunUnits),
            longterm_longest_run: this.convertDistanceToMeters(this.longtermLongestRun, this.distanceUnits),

            best5k_hours: this.best5kHours,
            best5k_minutes: this.best5kMins,
            best5k_seconds: this.best5kSecs,
            best5k: this.best5k,
            best10k_hours: this.best10kHours,
            best10k_minutes: this.best10kMins,
            best10k_seconds: this.best10kSecs,
            best10k: this.best10k,
            best_half_hours: this.bestHalfHours,
            best_half_minutes: this.bestHalfMins,
            best_half_seconds: this.bestHalfSecs,
            best_half: this.bestHalf,
            best_marathon_hours: this.bestMarathonHours,
            best_marathon_minutes: this.bestMarathonMins,
            best_marathon_seconds: this.bestMarathonSecs,
            best_marathon: this.bestMarathon,

            recent_races: this.recentRaces,
            recent_race_comments: this.recentRaceComments,
            recent_injuries: this.recentInjuries,
            injury_notes: this.injuryNotes,
            injuries: this.injuries,
            // injuries: [],
            // other_injuries: this.otherInjuries,

            plan: this.plan,
            categories: this.categories,
            categories2: this.categories2,
            winterraces: this.winterRaces,
            other_winter_races: this.otherWinterRaces,
            springraces: this.springRaces,
            other_spring_races: this.otherSpringRaces,
            summerraces: this.summerRaces,
            other_summer_races: this.otherSummerRaces,
            fallraces: this.fallRaces,
            other_fall_races: this.otherFallRaces,
            goal_race: this.goalRace,
            heartrate_monitor: this.heartrateMonitor,
            long_day: this.longDay,
            speed_day: this.speedDay,
            rest_day: this.restDay,
            trainingaspects: this.trainingAspects,
            other_training_aspects: this.otherTrainingAspects,
            xtraining_amount: this.xtrainingAmount,
            xtraining_days: this.xtrainingDays,
            xtraining_description: this.xtrainingDescription,
            xtrainingactivities: this.xtrainingActivities,
            other_xtraining_activities: this.otherXtrainingActivities,

            mile_minutes: this.mileMins,
            mile_seconds: this.mileSecs,
            mile_location: this.mileLocation,
            mile_surface: this.mileSurface,
            // mile_splits: this.mileSplits,
            mile_weather: this.mileWeather,
            mile_lap1: lap1inSecs,
            mile_lap2: lap2inSecs,
            mile_lap3: lap3inSecs,
            mile_lap4: lap4inSecs,
            mile_800: inSecs800,
            mile_1k: inSecs1k,
            mile_fastest_lap: fastestLapInSecs,
            mile_max_hr: this.mileMaxHR,
            estimate_mile: this.estimateMile,
            estimate_mile_race: this.estimateMileRace,

            last_updated_date: timeNow,
          }
        )
        // axios.patch('/api/users/'.concat(this.user.id.toString()).concat('/'),
        //   {
        //     // categories: this.categories,
        //     categories: [],
        //     // categories2: this.categories2,

        //   }
        // )
          .then(res => {
            console.log(res)
            this.getUserProfile()
            this.editing = false

            // Scroll the window back up after saving the profile
            window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
          })
          .catch(error => {
            console.log(error)
          })

      },



      profileSaved() {
        console.log('Profile Saved')

        this.$store.dispatch('sendEmail', { subject: 'Runner Updated Profile',
                                            message: 'This runner has just updated their profile: '+this.user.email+'\nTheir team is: '+this.user.team,
                                            from: 'myrundash@gmail.com',
                                            email: 'aakashkgoel@gmail.com',
                                            reply: 'aakashkgoel@gmail.com',
                                            userID: 1})

        if (this.user.team == 'MDI') {
          this.$store.dispatch('sendEmail', { subject: 'Runner Updated Profile',
                                            message: 'This runner has just updated their profile: '+this.user.email,
                                            from: 'myrundash@gmail.com',
                                            email: 'kevinsmith@marathondynamics.com',
                                            // email: 'aakashkgoel@gmail.com',
                                            reply: 'aakashkgoel@gmail.com',
                                            userID: 1})
        }

        this.getUserProfile()
        this.editing = false
      },
      cancelProfileEdit() {
        this.editing = false
      },
      makemecoach() {
        axios.patch('/api/users/'.concat(this.user.id.toString()).concat('/'), {
          is_coach: true
        })
          .then(res => {
            console.log(res)
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
</script>

<style>
  .user-profile p {
    margin-bottom: 0;
  }

  .section-header {
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserProfile.vue